'use strict';

var indigo$1 = require('../../../../_virtual/indigo.js_commonjs-exports.js');

Object.defineProperty(indigo$1.__exports, "__esModule", {
  value: true
});
indigo$1.__exports.default = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
indigo$1.__exports.default = _default;
